var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/carousel-module-arrow.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"o-carousel__button-svg\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 51.903 88.196\" style=\"enable-background:new 0 0 51.903 88.196;\" xml:space=\"preserve\">\n<g>\n\t<path class=\"o-carousel__button-svg--inner\" d=\"M46.95,44.047l-39.2,39.2l-2.8-2.8l36.3-36.4l-36.3-36.3l2.8-2.8L46.95,44.047z M7.75,83.247l-2.8-2.8\"></path>\n\t<polygon points=\"7.75,88.196 0.003,80.451 36.303,44.05 0,7.747 7.747,0 51.903,44.044 \t\"></polygon>\n</g>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/carousel-module-arrow.j2"] , dependencies)